module.exports = __webpack_public_path__ + "static/media/arrow-up.ff491fce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow-up.svg
// module id = 238
// module chunks = 0